const baseURL = "https://shf5w46ojd.execute-api.ap-south-1.amazonaws.com/dev/api/debitNote/"
// const baseURL = "http://localhost:5000/dev/api/debitNote/"


export const createDebitNote = baseURL+"createDebitNote"
export const getAllDebitNote = baseURL+"viewAllDebitNotesList/"
